<template>
  <div :id="componentId" :class="model.background">
    <div class="container relative mx-auto max-w-screen-xl py-4 md:py-8 lg:py-16">
      <Swiper
        :slides-per-view="1"
        class="w-full"
        :modules="modules"
        :pagination="navigationOptions"
        :autoplay="autoplayOptions"
      >
        <SwiperSlide v-for="(item, index) in model.slides" :key="index">
          <div
            class="slider-image flex h-[375px] items-center rounded-xl bg-cover bg-center bg-no-repeat md:h-[555px]"
            :style="{ backgroundImage: `url('${item.image}')` }"
          >
            <div class="z-[1] w-full px-4 py-12 md:ml-16 md:max-w-[425px] md:p-0">
              <div
                v-if="item.title"
                class="font-amaranth text-2xl md:mb-8 md:text-4xl xl:text-6xl"
                :class="model.textColor ? model.textColor : 'text-[color:var(--white)]'"
              >
                {{ item.title }}
              </div>
              <div
                v-if="item.text"
                class="mt-2 font-inter md:text-lg"
                :class="model.textColor ? model.textColor : 'text-[color:var(--white)]'"
              >
                {{ item.text }}
              </div>
              <VcButton
                v-if="item.buttonLink"
                :to="item.buttonLink"
                size="md"
                color="tertiary"
                class="mt-4 px-8 py-3 uppercase md:mt-12"
              >
                {{ item.buttonTitle }}

                <VcIcon class="ml-2" name="arrow-up-right" size="xs" />
              </VcButton>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <div class="flex flex-col">
        <div class="absolute bottom-[25px] left-[30px] z-10 md:bottom-[90px] md:left-[80px] lg:left-[80px]">
          <div class="vc-slider__pagination cursor-pointer justify-end md:justify-center lg:justify-start"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue"; // eslint-disable-line import/no-unresolved
import { getCurrentInstance } from "vue";

defineProps<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: Record<string, any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  settings: Record<string, any>;
}>();

const componentId = `vc-slider_${getCurrentInstance()!.uid}`;

const navigationOptions = {
  clickable: true,
  el: ".vc-slider__pagination",
  bulletClass: "vc-slider__bullet",
};

const autoplayOptions = {
  delay: 5000,
  disableOnInteraction: false,
};

const modules = [Autoplay, Pagination];
</script>

<style lang="scss">
.slider-image {
  @apply after:content-[''] after:absolute after:w-full after:h-full after:rounded-xl;

  &::after {
    background: linear-gradient(to right, rgba(41, 27, 15, 0.8), rgba(255, 255, 255, 0));
  }
}

.vc-slider {
  $self: &;

  &__pagination {
    display: flex;
  }

  &__bullet {
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 100%;
    margin-right: 10px;
    position: relative;

    &.swiper-pagination-bullet-active {
      background: #fff;
      width: 18px;
      height: 18px;

      &::after {
        background-color: #ff7112;
        content: "";
        width: 12px;
        height: 12px;
        display: block;
        border-radius: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
